export const defaultStoryRedirect = {
  buttonName: '',
  buttonColor: '',
  fontColor: '',
  linkType: 'custom',
  linkName: '',
  sportId: '',
  link: [],
  id: '',
}

export const defaultStoryRules = {
  type: 'link',
  linkType: 'custom',
  linkName: '',
  sportId: '',
  link: [],
  id: '',
  iconType: 'dark',
  rulesQuilText: {},
}

export const defaultPreview = {
  id: null,
  url: '',
  file: null,
  loading: false,
}

export const defaultCover = {
  id: null,
  preview: '',
  file: null,
  name: 'Story 1',
  isVideo: false,
  loading: false,
  isRedirectAvailable: false,
  isRulesAvailable: false,
  redirect: defaultStoryRedirect,
  rules: defaultStoryRules,
}

export const STORY_CONTENT_FORM_FIELDS = {
  preview: {
    ...defaultPreview,
  },
  stories: [
    { ...defaultCover },
  ],
}
